import React, { useState } from "react";
import "./DepositSlipForm.scss";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import SimpleFileUploadButton from "./SimpleFileUploadButton";
import DocumentViewer from "./DocumentViewerModal";
import { ReactComponent as Eye } from "assets/img/svg/eye_open.svg";
import { ReactComponent as CloseIcon } from "assets/img/svg/CrossIcon.svg";
import { getFormattedAmount } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const inputHeight = { height: "44px", width: "100%" };
const FileUploadedHolder = ({ viewer, setViewer }) => {
  if (!viewer?.s3Key) return null;

  return (
    <div className="df-uploaded-holder">
      <div className="df-uploaded-handler-name">
        {viewer?.name || "Attached file"}
      </div>
      <div>
        <Eye onClick={() => setViewer((prev) => ({ ...prev, open: true }))} />
        <CloseIcon onClick={() => setViewer({ open: false, s3Key: "" })} />
        <DocumentViewer
          open={viewer.open}
          s3Key={viewer.s3Key}
          title="Deposit slip"
          showDelete={true}
          onDelete={() => setViewer({ open: false, s3Key: "" })}
          onClose={() => setViewer((prev) => ({ ...prev, open: false }))}
        />
      </div>
    </div>
  );
};
const DepositSlipForm = ({ totalAmount = 0, onSave, depositForm }) => {
  const [viewer, setViewer] = useState(depositForm?.viewer);
  const [depositSlipNo, setDepositSlipNo] = useState(
    depositForm?.depositSlipNo
  );

  return (
    <div className="deposit-form">
      {/* HEADER */}
      <div className="df-header">
        <div className="df-title">Total amount to be deposited</div>
        <div className="df-amount">{getFormattedAmount(totalAmount)}</div>
      </div>

      {/* UPLOAD SECTION */}
      <div className="df-label">Upload deposit slip *</div>
      <FileUploadedHolder setViewer={setViewer} viewer={viewer} />

      <div className="">
        <SimpleFileUploadButton
          serviceName="STOCK_BRANCH"
          supportedFileTypes={["peg", "jpg", "png", "pdf"]}
          maxAllowedFileSize={2}
          onUploadSuccess={(file) => {
            setViewer((prev) => ({
              ...prev,
              name: file.name,
              s3Key: file.key,
            }));
          }}
        />
      </div>
      <div className="df-label mt-20">Deposit slip number *</div>
      <AInput
        className="df-input"
        placeholder="Enter slip number"
        value={depositSlipNo}
        style={inputHeight}
        maxLength={10}
        handler={(value) => setDepositSlipNo(value)}
      />

      {/* SAVE BUTTON */}
      <div className="mt-3">
        <AButton
          className="no-ml-btn"
          variant="primary_filled"
          updatedStyle={{ width: "100%" }}
          disabled={!(depositSlipNo && viewer?.name)}
          onClick={() => onSave({ viewer, depositSlipNo })}
        >
          Save
        </AButton>
      </div>
    </div>
  );
};

export default DepositSlipForm;
